import { render, staticRenderFns } from "./formSubCat.vue?vue&type=template&id=00304497"
import script from "./formSubCat.vue?vue&type=script&lang=js"
export * from "./formSubCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports